module.exports = __webpack_public_path__ + "img/empty-state-custom-survey.4e052171.svg";